import { LikeIcon } from '@vivino/js-react-common-ui';
import { useI18N } from '@vivino/js-web-common';
import cx from 'classnames';
import React, { ReactNode, useState } from 'react';

import styles from './sentimentTracker.module.scss';

const TRANSLATIONS = {
  thanks: 'common.thanks',
  wasThisHelpful: 'components.shared.sentiment_tracker.was_this_useful',
};

export enum Sentiment {
  POSITIVE = 'Positive',
  NEGATIVE = 'Negative',
}

interface Props {
  title?: string | ReactNode;
  sentiment?: Sentiment;
  onClick?: (sentiment: Sentiment) => void;
}

const SentimentTracker = ({ sentiment, title, onClick }: Props) => {
  const [sentimentState, setSentiment] = useState<Sentiment | null>(sentiment);
  const { t } = useI18N();
  const isPositive = sentimentState === Sentiment.POSITIVE;
  const isNegative = sentimentState === Sentiment.NEGATIVE;

  function handleSentimentChange(event, sentiment: Sentiment) {
    event.stopPropagation();

    if (sentimentState) {
      return;
    }
    setSentiment(sentiment);
    onClick?.(sentiment);
  }

  function getTitle() {
    if (sentimentState) {
      return title || t(TRANSLATIONS.thanks);
    }
    return title || t(TRANSLATIONS.wasThisHelpful);
  }

  return (
    <div className={styles.container}>
      <div className={styles.title}>{getTitle()}</div>
      <div className={styles.icons}>
        <div className={cx({ [styles.negative]: isNegative })}>
          <LikeIcon
            down
            filled={isNegative}
            data-testid="sentiment-no"
            onClick={(event) => handleSentimentChange(event, Sentiment.NEGATIVE)}
          />
        </div>
        <div className={cx({ [styles.positive]: isPositive })}>
          <LikeIcon
            data-testid="sentiment-yes"
            onClick={(event) => handleSentimentChange(event, Sentiment.POSITIVE)}
            filled={isPositive}
          />
        </div>
      </div>
    </div>
  );
};

export default SentimentTracker;
